import CheckCircleIcon from "assets/svg/CheckCirleIcon";
import CircleCancelIcon from "assets/svg/CircleCancelIcon";
import CircleWarningIcon from "assets/svg/CircleWarningIcon";
import theme from "themes/Theme";

export const getStatusBgColor = (status: string | null | undefined) => {
  if (status) {
    switch (status) {
      case "completed":
        return "rgb(11, 147, 149)";
      case "pending":
      case "suspended":
        return "rgb(255, 179, 0)";
      case "cancelled":
      case "failed":
      case "inactive":
        return "rgb(164, 13, 13)";
      case "unverified":
        return "rgb(190, 0, 73)";
      case "active":
        return "rgba(9, 130, 11, 1)";
      default:
        return "rgba(0, 0, 0, 0.89)";
    }
  } else {
    return "rgb(0, 0, 0)";
  }
};

export const getIconByStatus = (status: string) => {
  switch (status) {
    case "completed":
      return (
        <CheckCircleIcon
          width={18}
          height={18}
          color={theme.palette.custom?.green}
        />
      );
    case "pending":
      return <CircleWarningIcon width={18} height={18} />;
    case "cancelled":
      return <CircleCancelIcon width={18} height={18} />;
    default:
      return null;
  }
};

export const trimHash = (hash: string) => {
  return `${hash.slice(0, 7)}...${hash.slice(hash.length - 4)}`;
};
